import { createAction } from 'redux-actions';

export const resetLowStockItems = createAction(
  'RESET_INVENTORY_LOW_STOCK_ITEMS'
);

export const updateLowStockItemsSearchQuery = createAction(
  'UPDATE_INVENTORY_LOW_STOCK_ITEMS_SEARCH_QUERY'
);
